// Mock data for Umedpuri Bapu Saduthala Website

export const siteContent = {
  en: {
    nav: {
      home: "Home",
      about: "About Bapu",
      teachings: "Teachings",
      bhajans: "Bhajans",
      ashram: "Saduthala Ashram",
      gallery: "Gallery",
      contact: "Contact"
    },
    hero: {
      greeting: "Jai Shri Krishna",
      mainLine: "Yeh Din Bhi Chalejayege",
      meaning: "This time too shall pass",
      subtitle: "Welcome to the divine abode of Param Pujya Guru Shri Umedpuri Maharaj",
      buttons: {
        about: "About Bapu",
        teachings: "Teachings",
        contact: "Darshan Info"
      }
    },
    about: {
      title: "About Umedpuri Bapu",
      subtitle: "The Divine Journey of a Spiritual Master",
      content: [
        "Param Pujya Guru Shri Umedpuri Maharaj is a revered spiritual saint who has dedicated his life to spreading the message of peace, love, and devotion.",
        "Born with divine grace, Bapu has been guiding countless devotees on the path of spirituality and righteousness. His teachings emphasize the impermanence of worldly troubles and the eternal nature of the soul.",
        "The famous teaching 'Yeh Din Bhi Chalejayege' (This time too shall pass) has become a beacon of hope for millions, reminding us that both joy and sorrow are temporary, and we must remain steadfast in our faith.",
        "At Saduthala Ashram, Bapu continues to bless devotees with his divine presence, offering guidance, peace, and spiritual enlightenment to all who seek it."
      ],
      mission: {
        title: "Mission & Values",
        points: [
          "Spreading the message of peace and harmony",
          "Guiding devotees on the path of righteousness",
          "Serving humanity with love and compassion",
          "Preserving and promoting spiritual traditions"
        ]
      }
    },
    teachings: {
      title: "Teachings & Vichar",
      subtitle: "Divine Wisdom for Daily Life",
      items: [
        {
          title: "Patience in Adversity",
          content: "When difficulties come, remember - this too shall pass. Have patience and faith in the divine.",
          gujarati: "મુશ્કેલીઓ આવે ત્યારે યાદ રાખો - આ પણ પસાર થઈ જશે. ધીરજ રાખો અને ભગવાન પર વિશ્વાસ રાખો."
        },
        {
          title: "Service to Others",
          content: "True devotion is serving others selflessly. In helping others, we find our true purpose.",
          gujarati: "સાચી ભક્તિ એ નિઃસ્વાર્થ સેવા છે. બીજાઓની મદદ કરવામાં આપણે આપણો સાચો હેતુ શોધીએ છીએ."
        },
        {
          title: "Inner Peace",
          content: "Peace does not come from outside. Look within, and you will find the eternal peace of the soul.",
          gujarati: "શાંતિ બહારથી આવતી નથી. અંદર જુઓ, અને તમે આત્માની શાશ્વત શાંતિ પામશો."
        },
        {
          title: "Faith & Surrender",
          content: "Surrender your worries to the divine. Have complete faith, and everything will fall into place.",
          gujarati: "તમારી ચિંતાઓ ભગવાનને સમર્પિત કરો. સંપૂર્ણ વિશ્વાસ રાખો, બધું ઠીક થઈ જશે."
        },
        {
          title: "Simple Living",
          content: "Live simply, think deeply. Material possessions cannot bring lasting happiness.",
          gujarati: "સાદગીથી જીવો, ઊંડાણથી વિચારો. ભૌતિક વસ્તુઓ કાયમી સુખ આપી શકતી નથી."
        },
        {
          title: "Love for All",
          content: "See the divine in every being. Love all, serve all, and you will be blessed.",
          gujarati: "દરેક જીવમાં ભગવાનને જુઓ. બધાને પ્રેમ કરો, બધાની સેવા કરો, અને તમે આશીર્વાદિત થશો."
        }
      ]
    },
    bhajans: {
      title: "Bhajans & Devotional Songs",
      subtitle: "Listen to the Divine Melodies",
      description: "Experience the spiritual bliss through these devotional bhajans dedicated to Umedpuri Bapu."
    },
    ashram: {
      title: "Saduthala Ashram",
      subtitle: "The Sacred Abode of Peace",
      description: "Saduthala Ashram is a serene spiritual center where devotees come to seek blessings and guidance from Umedpuri Bapu. The ashram is known for its peaceful atmosphere and divine energy.",
      address: "MG6R+W23, Navapara, Saduthala, Gujarat 384315, India",
      timings: {
        title: "Darshan Timings",
        morning: "Morning: 6:00 AM - 11:00 AM",
        evening: "Evening: 4:00 PM - 8:00 PM"
      },
      importance: {
        title: "Importance of Saduthala",
        content: "Saduthala is a sacred place blessed by the presence of Umedpuri Bapu. Thousands of devotees visit this holy place to receive blessings, find inner peace, and connect with the divine energy that permeates the ashram."
      }
    },
    gallery: {
      title: "Photo Gallery",
      subtitle: "Divine Moments Captured"
    },
    contact: {
      title: "Contact & Blessings",
      subtitle: "Connect with Us",
      phone: "Phone / WhatsApp",
      phoneNumber: "+91 9825895999",
      sendPrayers: "Send Your Prayers",
      form: {
        name: "Your Name",
        mobile: "Mobile Number",
        message: "Your Message / Prayer",
        submit: "Send Blessings Request"
      },
      location: "Location"
    },
    footer: {
      tagline: "Spreading peace, love, and spirituality",
      madeBy: "Made with devotion by Kevin Patel, a devotee of Bapu",
      rights: "All rights reserved"
    }
  },
  gu: {
    nav: {
      home: "હોમ",
      about: "બાપુ વિશે",
      teachings: "શિક્ષણ",
      bhajans: "ભજનો",
      ashram: "સાદુથાલા આશ્રમ",
      gallery: "ગેલેરી",
      contact: "સંપર્ક"
    },
    hero: {
      greeting: "જય શ્રી કૃષ્ણ",
      mainLine: "યે દિન ભી ચલેજાયેગે",
      meaning: "આ દિવસ પણ પસાર થઈ જશે",
      subtitle: "પરમ પૂજ્ય ગુરુ શ્રી ઉમેદપુરી મહારાજના દિવ્ય ધામમાં આપનું સ્વાગત છે",
      buttons: {
        about: "બાપુ વિશે",
        teachings: "શિક્ષણ",
        contact: "દર્શન માહિતી"
      }
    },
    about: {
      title: "ઉમેદપુરી બાપુ વિશે",
      subtitle: "એક આધ્યાત્મિક ગુરુની દિવ્ય યાત્રા",
      content: [
        "પરમ પૂજ્ય ગુરુ શ્રી ઉમેદપુરી મહારાજ એક પૂજનીય આધ્યાત્મિક સંત છે જેમણે પોતાનું જીવન શાંતિ, પ્રેમ અને ભક્તિનો સંદેશ ફેલાવવા માટે સમર્પિત કર્યું છે.",
        "દિવ્ય કૃપા સાથે જન્મેલા, બાપુ અસંખ્ય ભક્તોને આધ્યાત્મિકતા અને ધર્મના માર્ગે માર્ગદર્શન આપી રહ્યા છે. તેમની શિક્ષાઓ સાંસારિક મુશ્કેલીઓની અસ્થાયીતા અને આત્માના શાશ્વત સ્વભાવ પર ભાર મૂકે છે.",
        "'યે દિન ભી ચલેજાયેગે' (આ દિવસ પણ પસાર થઈ જશે) આ પ્રસિદ્ધ શિક્ષણ લાખો લોકો માટે આશાનું કિરણ બની ગયું છે, જે આપણને યાદ અપાવે છે કે સુખ અને દુઃખ બંને અસ્થાયી છે, અને આપણે આપણી શ્રદ્ધામાં અડગ રહેવું જોઈએ.",
        "સાદુથાલા આશ્રમમાં, બાપુ તેમની દિવ્ય હાજરીથી ભક્તોને આશીર્વાદ આપવાનું ચાલુ રાખે છે, જે બધાને માર્ગદર્શન, શાંતિ અને આધ્યાત્મિક જ્ઞાન પ્રદાન કરે છે."
      ],
      mission: {
        title: "મિશન અને મૂલ્યો",
        points: [
          "શાંતિ અને સંવાદિતાનો સંદેશ ફેલાવવો",
          "ભક્તોને ધર્મના માર્ગે માર્ગદર્શન આપવું",
          "પ્રેમ અને કરુણા સાથે માનવતાની સેવા કરવી",
          "આધ્યાત્મિક પરંપરાઓનું જતન અને પ્રોત્સાહન"
        ]
      }
    },
    teachings: {
      title: "શિક્ષણ અને વિચાર",
      subtitle: "રોજિંદા જીવન માટે દિવ્ય જ્ઞાન",
      items: [
        {
          title: "વિપત્તિમાં ધીરજ",
          content: "મુશ્કેલીઓ આવે ત્યારે યાદ રાખો - આ પણ પસાર થઈ જશે. ધીરજ રાખો અને ભગવાન પર વિશ્વાસ રાખો.",
          gujarati: "મુશ્કેલીઓ આવે ત્યારે યાદ રાખો - આ પણ પસાર થઈ જશે. ધીરજ રાખો અને ભગવાન પર વિશ્વાસ રાખો."
        },
        {
          title: "સેવા",
          content: "સાચી ભક્તિ એ નિઃસ્વાર્થ સેવા છે. બીજાઓની મદદ કરવામાં આપણે આપણો સાચો હેતુ શોધીએ છીએ.",
          gujarati: "સાચી ભક્તિ એ નિઃસ્વાર્થ સેવા છે. બીજાઓની મદદ કરવામાં આપણે આપણો સાચો હેતુ શોધીએ છીએ."
        },
        {
          title: "આંતરિક શાંતિ",
          content: "શાંતિ બહારથી આવતી નથી. અંદર જુઓ, અને તમે આત્માની શાશ્વત શાંતિ પામશો.",
          gujarati: "શાંતિ બહારથી આવતી નથી. અંદર જુઓ, અને તમે આત્માની શાશ્વત શાંતિ પામશો."
        },
        {
          title: "શ્રદ્ધા અને સમર્પણ",
          content: "તમારી ચિંતાઓ ભગવાનને સમર્પિત કરો. સંપૂર્ણ વિશ્વાસ રાખો, બધું ઠીક થઈ જશે.",
          gujarati: "તમારી ચિંતાઓ ભગવાનને સમર્પિત કરો. સંપૂર્ણ વિશ્વાસ રાખો, બધું ઠીક થઈ જશે."
        },
        {
          title: "સાદું જીવન",
          content: "સાદગીથી જીવો, ઊંડાણથી વિચારો. ભૌતિક વસ્તુઓ કાયમી સુખ આપી શકતી નથી.",
          gujarati: "સાદગીથી જીવો, ઊંડાણથી વિચારો. ભૌતિક વસ્તુઓ કાયમી સુખ આપી શકતી નથી."
        },
        {
          title: "સર્વ પ્રત્યે પ્રેમ",
          content: "દરેક જીવમાં ભગવાનને જુઓ. બધાને પ્રેમ કરો, બધાની સેવા કરો, અને તમે આશીર્વાદિત થશો.",
          gujarati: "દરેક જીવમાં ભગવાનને જુઓ. બધાને પ્રેમ કરો, બધાની સેવા કરો, અને તમે આશીર્વાદિત થશો."
        }
      ]
    },
    bhajans: {
      title: "ભજનો અને ભક્તિ ગીતો",
      subtitle: "દિવ્ય ધૂનો સાંભળો",
      description: "ઉમેદપુરી બાપુને સમર્પિત આ ભક્તિ ભજનો દ્વારા આધ્યાત્મિક આનંદનો અનુભવ કરો."
    },
    ashram: {
      title: "સાદુથાલા આશ્રમ",
      subtitle: "શાંતિનું પવિત્ર ધામ",
      description: "સાદુથાલા આશ્રમ એક શાંત આધ્યાત્મિક કેન્દ્ર છે જ્યાં ભક્તો ઉમેદપુરી બાપુ પાસેથી આશીર્વાદ અને માર્ગદર્શન મેળવવા આવે છે. આશ્રમ તેની શાંતિપૂર્ણ વાતાવરણ અને દિવ્ય ઊર્જા માટે જાણીતું છે.",
      address: "MG6R+W23, નવાપરા, સાદુથાલા, ગુજરાત 384315, ભારત",
      timings: {
        title: "દર્શન સમય",
        morning: "સવાર: સવારે 6:00 થી 11:00",
        evening: "સાંજ: સાંજે 4:00 થી 8:00"
      },
      importance: {
        title: "સાદુથાલાનું મહત્વ",
        content: "સાદુથાલા એ ઉમેદપુરી બાપુની હાજરીથી આશીર્વાદિત પવિત્ર સ્થળ છે. હજારો ભક્તો આશીર્વાદ મેળવવા, આંતરિક શાંતિ મેળવવા અને આશ્રમમાં વ્યાપેલી દિવ્ય ઊર્જા સાથે જોડાવા આ પવિત્ર સ્થળની મુલાકાત લે છે."
      }
    },
    gallery: {
      title: "ફોટો ગેલેરી",
      subtitle: "દિવ્ય ક્ષણો કેપ્ચર"
    },
    contact: {
      title: "સંપર્ક અને આશીર્વાદ",
      subtitle: "અમારો સંપર્ક કરો",
      phone: "ફોન / WhatsApp",
      phoneNumber: "+91 9825895999",
      sendPrayers: "તમારી પ્રાર્થનાઓ મોકલો",
      form: {
        name: "તમારું નામ",
        mobile: "મોબાઈલ નંબર",
        message: "તમારો સંદેશ / પ્રાર્થના",
        submit: "આશીર્વાદ વિનંતી મોકલો"
      },
      location: "સ્થાન"
    },
    footer: {
      tagline: "શાંતિ, પ્રેમ અને આધ્યાત્મિકતાનો પ્રસાર",
      madeBy: "કેવિન પટેલ દ્વારા ભક્તિ સાથે બનાવેલ, બાપુના ભક્ત",
      rights: "સર્વ હક્ક આરક્ષિત"
    }
  }
};

export const bhajans = [
  {
    id: 1,
    title: { en: "Bhajan 1", gu: "ભજન ૧" },
    youtubeUrl: "https://youtu.be/RqBkkK3mnA8?si=VPKq4vwPvY4c8MMo",
    embedId: "RqBkkK3mnA8"
  },
  {
    id: 2,
    title: { en: "Bhajan 2", gu: "ભજન ૨" },
    youtubeUrl: "https://youtu.be/PME4jFyQcVw?si=5MS8f3Fp4Svng8VL",
    embedId: "PME4jFyQcVw"
  },
  {
    id: 3,
    title: { en: "Bhajan 3", gu: "ભજન ૩" },
    youtubeUrl: "https://youtu.be/f5U3xyYkjS8?si=STk-TpaV6VR-ClrU",
    embedId: "f5U3xyYkjS8"
  }
];

export const galleryImages = [
  {
    id: 1,
    src: "https://customer-assets.emergentagent.com/job_umedpuri-bapu/artifacts/msgtxeli_WhatsApp%20Image%202026-01-17%20at%209.07.20%20AM.jpeg",
    alt: { en: "Param Pujya Guru Shri Umedpuri Maharaj", gu: "પરમ પૂજ્ય ગુરુ શ્રી ઉમેદપુરી મહારાજ" }
  }
];

export const bapuImage = "https://customer-assets.emergentagent.com/job_umedpuri-bapu/artifacts/msgtxeli_WhatsApp%20Image%202026-01-17%20at%209.07.20%20AM.jpeg";
